import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";

import { Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
//import Radio from "@material-ui/core/Radio";
//import RadioGroup from "@material-ui/core/RadioGroup";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
//import Tabs from "@material-ui/core/Tabs";
//import Tab from "@material-ui/core/Tab";
//import List from "@material-ui/core/List";
//import ListItem from "@material-ui/core/ListItem";
//import ListItemIcon from "@material-ui/core/ListItemIcon";
//import ListItemText from "@material-ui/core/ListItemText";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

//import CreateProfileDialog from "./CreateProfileDialog";
import OverrideDialog from "./OverrideDialog";
import Picture from "../Common/Picture";
import CloseIcon from "../Common/CloseIcon";
import CapturedPhoto from "./CapturedPhoto";

//import eyeIcon from "../../assets/img/icons/eye_icon.png";

import colors from "../../assets/style/colors";

import { isUnknownProfile } from "../../utils/profile";

import {
  CONTEXT,
  OCR,
  LPR,
  driver,
  truck,
  trailer,
} from "../../constants/common";

const styles = (theme) => ({
  titleBar: {
    fontWeight: "500",
  },
  closeBtn: {
    display: "flex",
    justify: "flex-end",
    padding: "0px 24px",
  },
  indicator: {
    display: "none",
  },
  root: {
    fontSize: "1em",
    fontWeight: "normal",
    color: colors.black54,
    minWidth: "100px",
    opacity: "1.0",
    border: "1px solid " + colors.veryLighPink,
    paddingTop: "3px !important",
  },
  selected: {
    color: colors.black87,
    fontWeight: "500",
    borderTop: "4px solid " + colors.primary,
    paddingTop: "0px !important",
  },
  block: {
    padding: "10px",
    [theme.breakpoints.up("lg")]: {
      margin: "0px 20px",
    },
  },
  recognitionTitle: {
    color: colors.black87,
    borderBottom: "1px solid " + colors.black23,
    fontWeight: "500",
    marginBottom: "20px",
  },
  btnGroup: {
    margin: "50px 0px 20px 0px",
    textAlign: "center",
    "& button": {
      margin: "0px 10px",
    },
  },
  picture: {
    textAlign: "center",
    height: "120px",
    lineHeight: "120px",
  },
  optionsContainer: {
    paddingTop: "8px",
  },
  option: {
    marginBottom: "5px",
  },
  input: {
    width: "250px",
  },
  viewMore: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  rootIcon: {
    minWidth: "36px",
  },
  insetItem: {
    paddingLeft: "36px",
  },
});

const DetectionDetailsNew = (props) => {
  const { classes, type } = props;
  const [tab /*setTab*/] = React.useState(0);
  const [detections, setDetections] = React.useState([]);
  //const [potentialProfiles, setPotentialProfiles] = React.useState([]);

  const { dacId, event_group_id } = props.details;
  const {
    matchedProfile,
    lpr,
    ocr,
    contextPhotos,
    fr,
  } = props.details.detection;

  React.useEffect(() => {
    if (detections.length === 0) {
      let newDetections = [];
      //let potentialProfiles = {};
      // Add lpr detections
      if (lpr && lpr.length > 0) {
        lpr.forEach((d) => {
          // console.log(d);
          // if (d.profile && d.profile.id && !isUnknownProfile(d.profile.id)) {
          //   if (potentialProfiles[d.profile.id].id) {
          //     potentialProfiles[d.profile.id].matchedPhotos++;
          //   } else {
          //     potentialProfiles[d.profile.id].id = d.profile.id;
          //     potentialProfiles[d.profile.id].matchedPhotos = 1;
          //   }
          // }
          newDetections.push(d);
        });
      }
      // Add ocr detections
      if (ocr && ocr.length > 0) {
        ocr.forEach((d) => {
          // console.log(d);
          // if (d.profile && d.profile.id && !isUnknownProfile(d.profile.id)) {
          //   if (potentialProfiles[d.profile.id].id) {
          //     potentialProfiles[d.profile.id].matchedPhotos++;
          //   } else {
          //     potentialProfiles[d.profile.id].id = d.profile.id;
          //     potentialProfiles[d.profile.id].matchedPhotos = 1;
          //   }
          // }
          newDetections.push(d);
        });
      }
      //setPotentialProfiles(potentialProfiles);
      setDetections(newDetections);
    }
  }, [detections.length, lpr, ocr]);

  const renderResults = () => {
    return (
      <Grid
        container
        direction="column"
        alignItems="stretch"
        style={{ minWidth: "800px" }}
      >
        <Grid item style={{ margin: "30px 0px" }}>
          <Grid container justify="center">
            <Grid item style={{ height: "32px", lineHeight: "32px" }}>
              <span style={{ color: colors.black54 }}>
                {I18n.get("site_highestScoreMatch")}{" "}
              </span>
              <span className="text-87 bold-500">
                {props.matchedProfile && props.matchedProfile.name}
              </span>
            </Grid>
            <Grid item style={{ marginLeft: "50px" }}>
              {/*<OverrideDialog />*/}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item xs={6}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      {I18n.get("site_capturedPhotos") +
                        " - " +
                        I18n.get("site_lpr")}
                    </TableCell>
                    <TableCell>{I18n.get("site_profilesFound")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      {lpr && lpr.length > 0
                        ? lpr.map(
                            (lp, index) =>
                              lp.text +
                              " (" +
                              parseInt(lp.confidenceIndex * 100) +
                              "%)"
                          )
                        : I18n.get("site_noLPR")}
                    </TableCell>
                    <TableCell>ok</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            <Grid item xs={6}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      {I18n.get("site_capturedPhotos") +
                        " - " +
                        I18n.get("site_ocr")}
                    </TableCell>
                    <TableCell>{I18n.get("site_profilesFound")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ocr && ocr.length > 0
                    ? ocr.map((oc, index) => (
                        <TableRow key={oc.text + index}>
                          <TableCell
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Box
                              style={{
                                marginRight: "10px",
                                width: "70px",
                                height: "70px",
                                border: "1px solid " + colors.veryLighPink,
                                display: "flex",
                                alignItems: "center",
                                overflow: "hidden",
                              }}
                            >
                              <Picture url={oc.croppedImage} width={70} />
                            </Box>
                            <span className="text-54">{oc.text}</span>
                          </TableCell>
                          <TableCell>
                            {oc.profile && oc.profile.name && (
                              <Link
                                to={"/profiles/" + oc.profile.id}
                                style={{ color: colors.primary }}
                              >
                                {oc.profile.name}
                              </Link>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    : I18n.get("site_noOCR")}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderSummary = () => {
    return (
      <Grid container direction="column" alignItems="stretch">
        <Grid item className={classes.block}>
          <Box className={classes.recognitionTitle}>
            {I18n.get("site_capturedPhotos")}
          </Box>
          <Grid container>
            {contextPhotos.map((rec, index) => (
              <CapturedPhoto
                key={index + "context"}
                type={CONTEXT}
                img={rec}
                values={[]}
                matched={false}
              />
            ))}
            {lpr.map((rec, index) => (
              <CapturedPhoto
                key={rec.text + index + "lpr"}
                type={LPR}
                img={rec.croppedImage}
                values={[rec.text]}
                matched={
                  rec.profile &&
                  !isUnknownProfile(matchedProfile.id) &&
                  rec.profile.id === matchedProfile.id
                }
              />
            ))}
            {ocr.map((rec, index) => (
              <CapturedPhoto
                key={index + "ocr"}
                type={OCR}
                img={rec.croppedImage}
                values={[rec.text]}
                matched={
                  rec.profile &&
                  !isUnknownProfile(matchedProfile.id) &&
                  rec.profile.id === matchedProfile.id
                }
              />
            ))}
            {/* {capturedImages.map(img => (
              <Grid
                item
                key={img}
                style={{
                  maxHeight: "70px",
                  maxWidth: "70px",
                  border: "1px solid " + colors.veryLighPink,
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                  margin: "0px 10px 10px 0px"
                }}
              >
                <Picture url={img} width="70px" />
              </Grid>
            ))} */}
          </Grid>
        </Grid>
        {/* <Grid item className={classes.block}> */}
        {/* <Grid container justify="center"> */}
        {/* <Grid item xs={4} style={{ paddingRight: "20px" }}> */}
        {/* <Box style={{ maxWidth: "400px", margin: "auto" }}>
            <Grid container className={classes.recognitionTitle}>
              <Grid item xs={6} style={{ lineHeight: "32px" }}>
                {I18n.get("site_highestScoreProfile")}
              </Grid>
              <Grid item xs={6} style={{ textAlign: "right" }}> */}
        {/* </Grid>
            </Grid>
            {renderProfile(matchedProfile)}
          </Box> */}
        {/* </Grid> */}
        {/*<Grid item xs={6} style={{ paddingLeft: "20px" }}>
              <Box
                className={classes.recognitionTitle}
                style={{ height: "32px", lineHeight: "32px" }}
              >
                {I18n.get("site_otherProfilesFound")}
              </Box>
                  </Grid>*/}
        {/* </Grid> */}
        {/* </Grid> */}
      </Grid>
    );
  };

  /*const renderProfile = profile => {
    if (!profile) {
      return null;
    }

    return (
      <Grid container>
        <Grid
          item
          style={{
            marginRight: "10px",
            width: "72px",
            height: "72px",
            border: "1px solid " + colors.veryLighPink
          }}
        >
          <Picture
            url={
              profile.images && profile.images.length > 0
                ? profile.images[0].url || profile.images[0]
                : null
            }
            width="70px"
          />
        </Grid>
        <Grid item>
          <Grid container direction="column">
            <Grid item>
              <Link
                to={"/profiles/" + profile.id}
                style={{ color: colors.primary }}
              >
                {profile.name}
              </Link>
            </Grid>
            <Grid item>
              {profile.tag && (
                <Grid container>
                  <Grid
                    item
                    style={{
                      width: "7px",
                      height: "25px",
                      marginRight: "5px",
                      backgroundColor: "#" + profile.tag.color_rgb
                    }}
                  />
                  <Grid
                    item
                    style={{ color: colors.black54, paddingTop: "2px" }}
                  >
                    {profile.tag["name_" + props.language]}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };*/

  /*const renderFr = () => {
    return (
      <Grid container style={{ padding: "0px 50px" }}>
        {fr && fr.length > 0
          ? fr.map((img, index) => (
              <Grid item key={index} style={{ margin: "0px 10px" }}>
                <Picture
                  url={img}
                  alt="fr_photo"
                  style={{ maxHeight: "120px" }}
                />
              </Grid>
            ))
          : I18n.get("site_noPhotoFound")}
      </Grid>
    );
  };*/

  /*const renderLPR = () => {
    return (
      <Grid container>
        <Grid item xs={5} className={classes.optionsContainer}>
          <RadioGroup
            name="licensePlate"
            value={licensePlate}
            onChange={e => setLicensePlate(e.target.value)}
          >
            {lpr && lpr.length > 0
              ? lpr.map((lp, index) => (
                  <FormControlLabel
                    key={index}
                    value={lp.text}
                    control={<Radio color="primary" />}
                    label={
                      lp.text + " (" + parseInt(lp.confidenceIndex * 100) + "%)"
                    }
                    classes={{ label: "text-54" }}
                    className={classes.option}
                  />
                ))
              : I18n.get("site_noLPR")}
          </RadioGroup>
        </Grid>
        {lpr && lpr.length > 0 && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_context")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={lpr[0].contextImage} alt="context_image" />
            </Box>
          </Grid>
        )}
        {licensePlate && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_cropped")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={licensePlate.croppedImage} alt="cropped_image" />
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  const renderOCR = () => {
    return (
      <Grid container>
        <Grid item xs={5} className={classes.optionsContainer}>
          <List>
            {ocr &&
              ocr.slice(0, showMoreOCR ? ocr.length : 3).map((vi, index) => (
                <ListItem key={index} onClick={() => setVehicleId(index)}>
                  {index === vehicleId && (
                    <ListItemIcon classes={{ root: classes.rootIcon }}>
                      <img src={eyeIcon} alt="eye" />
                    </ListItemIcon>
                  )}
                  <ListItemText
                    inset={index !== vehicleId}
                    classes={{
                      root: classes.viewMore,
                      inset: classes.insetItem
                    }}
                    primary={
                      vi.text + " (" + parseInt(vi.confidenceIndex * 100) + "%)"
                    }
                  />
                </ListItem>
              ))}
            {ocr && ocr.length > 0 ? (
              <ListItem>
                <ListItemText
                  inset
                  primary={
                    showMoreOCR
                      ? I18n.get("site_viewLess")
                      : I18n.get("site_view") +
                        " " +
                        (ocr.length - 3) +
                        " " +
                        I18n.get("site_more")
                  }
                  onClick={() => setShowMoreOCR(!showMoreOCR)}
                  classes={{
                    root: classes.viewMore,
                    inset: classes.insetItem
                  }}
                />
              </ListItem>
            ) : (
              I18n.get("site_noOCR")
            )}
          </List>
        </Grid>
        {ocr[vehicleId] && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_context")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={ocr[vehicleId].contextImage} alt="context_image" />
            </Box>
          </Grid>
        )}
        {ocr[vehicleId] && (
          <Grid item xs>
            <Box className="text-54 text-center">
              {I18n.get("site_cropped")}
            </Box>
            <Box className={classes.picture}>
              <Picture url={ocr[vehicleId].croppedImage} alt="cropped_image" />
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };*/

  return (
    <Grid container direction="column" alignItems="stretch">
      <Grid item>
        <Grid container direction="row-reverse" className={classes.titleBar}>
          <Grid item xs={2} className={classes.closeBtn}>
            <CloseIcon closeFunction={props.close} />
          </Grid>
          <Grid item xs={8} className="text-87 text-center">
            {I18n.get("site_" + type).toUpperCase() +
              " - " +
              I18n.get("site_details").toUpperCase()}
          </Grid>
        </Grid>
      </Grid>
      {/*<Grid
        item
        style={{ margin: "20px 0px", maxWidth: "1000px", margin: "auto" }}
      >
        <Tabs
          value={tab}
          onChange={(e, value) => setTab(value)}
          classes={{ indicator: classes.indicator }}
          centered
        >
          {[I18n.get("site_summary"), I18n.get("site_results")].map(
            (tab, index) => (
              <Tab
                key={tab}
                classes={{
                  root: classes.root,
                  selected: classes.selected
                }}
                label={tab}
                disableRipple={true}
                style={{
                  height: "40px",
                  padding: 0,
                  minHeight: "40px",
                  borderRight:
                    index === 0 ? "none" : "1px solid " + colors.veryLighPink
                }}
              />
            )
          )}
        </Tabs>
              </Grid>*/}
      <Grid
        item
        style={{ maxWidth: "1000px", minWidth: "500px", margin: "auto" }}
      >
        {tab === 0 && renderSummary()}
        {tab === 1 && renderResults()}
        {/*<Box>{type === "driver" && renderFr()}</Box>
        {type !== "driver" && (
          <Grid container justify="center">
            <Grid item xs={6} lg={5} xl={4} className={classes.block}>
              <Box className={classes.recognitionTitle}>
                {I18n.get("site_licensePlateRecognition")}
              </Box>
              {Object.keys(lpr).length > 0
                ? renderLPR()
                : I18n.get("site_noLPR")}
            </Grid>
            <Grid item xs={6} lg={5} xl={4} className={classes.block}>
              <Box className={classes.recognitionTitle}>
                {I18n.get("site_opticalCharacterRecognition")}
              </Box>
              {Object.keys(ocr).length > 0
                ? renderOCR()
                : I18n.get("site_noOCR")}
            </Grid>
          </Grid>
              )*/}
      </Grid>
      <Grid item className="text-center" style={{ margin: "20px 0px" }}>
        <Button
          color="primary"
          onClick={props.close}
          style={{ marginRight: "20px" }}
        >
          {I18n.get("site_close")}
        </Button>
        <OverrideDialog
          profileType={type}
          currentProfile={matchedProfile}
          details={{
            dacId,
            detectionId: event_group_id,
            handleProfileOverride: () => null,
            ocr,
            lpr,
            fr,
          }}
          language={props.language}
          blockLiveEvents={true}
          zoneId={props.zoneId}
          buttonVariant="contained"
        />
      </Grid>
    </Grid>
  );
};

DetectionDetailsNew.propTypes = {
  type: PropTypes.oneOf([driver, truck, trailer]),
  details: PropTypes.shape({
    dacId: PropTypes.any.isRequired,
    event_group_id: PropTypes.any.isRequired,
    detection: PropTypes.shape({
      matchedProfile: PropTypes.object,
      capturedImages: PropTypes.array,
      fr: PropTypes.array,
      ocr: PropTypes.array,
      lpr: PropTypes.array,
    }),
  }),
  handleProfileCreated: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
};

export default withStyles(styles)(DetectionDetailsNew);
